const PROCESSING_TASKS_STORAGE_KEY = "octopus:local-processing-tasks";
const PROCESSING_TASKS_CACHE_KEY = "octopus:processing-tasks-cache";
const MAX_LOCAL_PROCESSING_TASKS = 100;
const MAX_CACHED_PROCESSING_TASKS = 200;
const CACHED_PROCESSING_TASK_TTL_MS = 60 * 60 * 1000;
export const PROCESSING_TASKS_CHANGED_EVENT = "octopus:processing-tasks-changed";

function isCacheableTask(task) {
    return task &&
        typeof task === "object" &&
        task.id !== undefined &&
        task.id !== null &&
        task.id !== "" &&
        String(task.status || "").toUpperCase() !== "PROCESSING";
}

function readTasks() {
    try {
        return JSON.parse(window.localStorage.getItem(PROCESSING_TASKS_STORAGE_KEY)) || [];
    } catch (error) {
        return [];
    }
}

function writeTasks(tasks, changedTask = null) {
    window.localStorage.setItem(
        PROCESSING_TASKS_STORAGE_KEY,
        JSON.stringify(tasks.slice(-MAX_LOCAL_PROCESSING_TASKS))
    );
    window.dispatchEvent(new CustomEvent(PROCESSING_TASKS_CHANGED_EVENT, {
        detail: { task: changedTask }
    }));
}

export function getLocalProcessingTasks() {
    return readTasks().filter(task => !(task?.source === "local" && task?.type === "Validation"));
}

export function getCachedProcessingTasks() {
    try {
        const cachedTasks = JSON.parse(window.localStorage.getItem(PROCESSING_TASKS_CACHE_KEY)) || [];
        return cachedTasks.filter(task =>
            isCacheableTask(task) &&
            task?.cachedAt &&
            Date.now() - Number(task.cachedAt) < CACHED_PROCESSING_TASK_TTL_MS
        );
    } catch (error) {
        return [];
    }
}

export function cacheProcessingTasks(tasks) {
    const mergedTasks = [...tasks, ...getCachedProcessingTasks()];
    const seenTasks = new Set();
    const cacheableTasks = [];

    mergedTasks
        .filter(task => isCacheableTask(task) && task?.source !== "local")
        .forEach(task => {
            if (seenTasks.has(task.id)) {
                return;
            }

            seenTasks.add(task.id);
            cacheableTasks.push({
                ...task,
                cachedAt: task.cachedAt || Date.now()
            });
        });

    window.localStorage.setItem(
        PROCESSING_TASKS_CACHE_KEY,
        JSON.stringify(cacheableTasks.slice(0, MAX_CACHED_PROCESSING_TASKS))
    );
}

export function startLocalProcessingTask(task) {
    const id = task.id || `${task.source || "task"}-${Date.now()}`;
    const nextTask = {
        source: "local",
        status: "PROCESSING",
        startTime: Date.now(),
        ...task,
        id
    };

    const tasks = readTasks().filter(item => item.id !== id);
    writeTasks([...tasks, nextTask], nextTask);
    return id;
}

export function finishLocalProcessingTask(id) {
    if (!id) {
        return;
    }

    const tasks = readTasks();
    let completedTask = null;
    const nextTasks = tasks.map(task => {
        if (task.id !== id) {
            return task;
        }

        completedTask = {
            ...task,
            status: "COMPLETE",
            completedTime: Date.now()
        };
        return completedTask;
    });

    writeTasks(nextTasks, completedTask);
}
